import { Middleware } from 'redux'
import { getAuthGeneration, invalidateAuthGeneration } from '../../helpers/authSession'
import { LOGOUT_USER } from '../actions/auth/authActionTypes'
import { ApplicationState, ReduxDispatch } from './models'

// Keep responses from a previous account out of Redux and persisted storage.
export const sessionThunk: Middleware<ReduxDispatch, ApplicationState, ReduxDispatch> =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action !== 'function') {
      if (action.type === LOGOUT_USER) invalidateAuthGeneration()
      return next(action)
    }
    const generation = getAuthGeneration()
    const sessionDispatch: ReduxDispatch = (nextAction: Parameters<ReduxDispatch>[0]) => {
      if (generation === getAuthGeneration()) return dispatch(nextAction)
    }
    const result = action(sessionDispatch, getState, undefined)
    if (!result || typeof result.then !== 'function') return result

    // Abandon completion delivery after logout, including await/then/catch callers.
    // Rejecting instead would still run old error handlers against the next account.
    return new Promise((resolve, reject) => {
      Promise.resolve(result).then(
        (value) => {
          if (generation === getAuthGeneration()) resolve(value)
        },
        (error) => {
          if (generation === getAuthGeneration()) reject(error)
        }
      )
    })
  }
